export function copyToClipboard(text) {
  if (navigator && navigator.clipboard)
    return navigator.clipboard.writeText(text)

  // For mobile browsers
  let textarea

  try {
    textarea = document.createElement('textarea')
    textarea.setAttribute('readonly', true)
    textarea.setAttribute('contenteditable', true)
    textarea.style.position = 'fixed' // prevent scroll from jumping to the bottom when focus is set.
    textarea.value = text

    document.body.appendChild(textarea)

    textarea.focus()
    textarea.select()

    const range = document.createRange()
    range.selectNodeContents(textarea)

    const sel = window.getSelection()
    sel.removeAllRanges()
    sel.addRange(range)

    textarea.setSelectionRange(0, textarea.value.length)
    return Promise.resolve()
  } catch (err) {
    console.error(err)
    return Promise.error(err)
  } finally {
    document.body.removeChild(textarea)
  }
}
